// pt translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const pt = {
    // Common
    "common.loading": "Carregando...",
    "common.save": "Salvar",
    "common.cancel": "Cancelar",
    "common.delete": "Excluir",
    "common.edit": "Editar",
    "common.submit": "Enviar",
    "common.logout": "Sair",
    "common.login": "Entrar",
    "common.register": "Cadastrar",
    
    // Auth
    "auth.welcome": "Bem-vindo",
    "auth.signIn": "Entre na sua conta",
    "auth.email": "E-mail",
    "auth.password": "Senha",
    "auth.loginButton": "Entrar",
    
    // Navigation
    "nav.dashboard": "Painel",
    "nav.releases": "Lançamentos",
    "nav.payouts": "Pagamentos",
    "nav.support": "Suporte",
    "nav.referrals": "Indicações",
    "nav.profile": "Perfil",
    
    // Dashboard
    "dashboard.welcome": "Bem-vindo",
    "dashboard.subtitle": "Gerencie sua música, acompanhe seus lançamentos e veja seus ganhos.",
    "dashboard.totalReleases": "Total de Lançamentos",
    "dashboard.totalTracks": "Total de Faixas",
    "dashboard.balance": "Saldo Atual",
    "dashboard.withdrawable": "Disponível para Saque",
    "dashboard.recentReleases": "Lançamentos Recentes",
    "dashboard.newRelease": "Novo Lançamento",
    "dashboard.requestPayout": "Solicitar Pagamento",
    
    // Analytics
    "analytics.title": "Estatísticas",
    "analytics.subtitle": "Acompanhe o desempenho dos seus lançamentos",
    "analytics.totalStreams": "Total de Reproduções",
    "analytics.listeners": "Ouvintes",
    "analytics.estimatedEarnings": "Ganhos Estimados",
    "analytics.monthlyGrowth": "Crescimento Mensal",
    "analytics.streamsChart": "Gráfico de Reproduções",
    "analytics.platformDistribution": "Distribuição por Plataforma",
    "analytics.topTracks": "Faixas Populares",
    "analytics.trackName": "Nome da Faixa",
    "analytics.streams": "reproduções",
    "analytics.comingSoonTitle": "Em Breve",
    "analytics.comingSoonDesc": "Análises detalhadas e estatísticas estarão disponíveis em breve. Com a integração artist.tools, você poderá acompanhar todos os dados das suas plataformas em um só lugar.",
    "common.comingSoon": "Em Breve",
    
    // Payouts
    "payouts.title": "Gerencie Seus Ganhos",
    "payouts.subtitle": "Retire facilmente seus ganhos musicais. Solicite um pagamento com mínimo de $50.",
    "payouts.fastPayment": "Pagamento rápido",
    "payouts.secureTransfer": "Transferência segura",
    "payouts.totalBalance": "Saldo Total",
    "payouts.withdrawableBalance": "Disponível para Saque",
    "payouts.requestPayout": "Solicitar Pagamento",
    "payouts.payoutHistory": "Histórico de Pagamentos",
    "payouts.noPayouts": "Ainda sem solicitações de pagamento",
    "payouts.noPaymentMethod": "Nenhum Método de Pagamento",
    "payouts.addMethodDesc": "Adicione um método de pagamento para sacar seus ganhos.",
    "payouts.addMethod": "Adicionar Método de Pagamento",
    "payouts.changeMethodVerification": "Verificação por email necessária para alterar seu método de pagamento atual",
    "payouts.availableBalance": "Saldo Disponível",
    "payouts.pendingBalance": "Saldo Pendente",
    "payouts.withdrawalHistory": "Histórico de Saques",
    "payouts.requestWithdrawal": "Solicitar Saque",
    "payouts.minWithdrawal": "Saque mínimo: $50",
    "payouts.manageEarnings": "Gerencie seus ganhos",
    "payouts.createRequest": "Criar Solicitação de Pagamento",
    "payouts.amount": "Valor",
    "payouts.accountHolder": "Titular da Conta",
    "payouts.bankName": "Nome do Banco",
    "payouts.minAmount": "O valor mínimo de saque é $50",
    "payouts.insufficientBalance": "Saldo insuficiente",
    "payouts.fillRequired": "Por favor preencha todos os campos obrigatórios",
    "payouts.requestCreated": "Solicitação de pagamento criada",
    "payouts.requestFailed": "Solicitação falhou",
    "payouts.minNotMet": "Mínimo não atingido",
    "payouts.minNotMetMsg": "Você precisa de pelo menos $50 de saldo disponível para solicitar um pagamento.",
    "payouts.statusRequested": "Solicitado",
    "payouts.statusPaid": "Pago",
    "payouts.paymentMethod": "Método de Pagamento",
    "payouts.bankTransfer": "Transferência Bancária",
    "payouts.paypalEmail": "Email do PayPal",
    "payouts.paypalNote": "Digite o email associado à sua conta PayPal",
    "payouts.fillPaypalRequired": "Por favor digite o email do PayPal e o nome do titular",
    "payouts.selectCountry": "Selecione seu país",
    "payouts.tabProfile": "Perfil de Pagamento",
    "payouts.tabMethod": "Método de Pagamento",
    "payouts.tabRequests": "Solicitações de Saque",
    "payouts.requirements": "Requisitos para Saque",
    "payouts.completeProfile": "Complete seu perfil de pagamento (Identidade e Endereço)",
    "payouts.addPaymentMethod": "Adicione um método de pagamento (Banco ou PayPal)",
    "payouts.verifyPaymentMethod": "Verifique seu método de pagamento",
    "payouts.profileComplete": "Concluído",
    "payouts.savedProfile": "Informações de Perfil Salvas",
    "payouts.fullName": "Nome Completo",
    "payouts.phoneNumber": "Telefone",
    "payouts.location": "Localização",
    "payouts.profileType": "Tipo de Perfil",
    "payouts.individual": "Individual",
    "payouts.business": "Empresa / Negócio",
    "payouts.edit": "Editar",
    
    // Statuses
    "status.draft": "Rascunho",
    "status.submitted": "Enviado",
    "status.approved": "Aprovado",
    "status.rejected": "Rejeitado",
    "status.live": "Ao Vivo",
    
    // Validation
    "validation.audioRequired": "O arquivo de áudio é obrigatório",
    "validation.audioFormatWav": "O arquivo de áudio deve estar no formato WAV ou FLAC",
    "validation.titleRequired": "O título é obrigatório",
    "validation.titleLanguageRequired": "O idioma do título é obrigatório",
    "validation.primaryArtistRequired": "Pelo menos um artista principal é necessário",
    "validation.primaryGenreRequired": "A seleção do gênero principal é obrigatória",
    "validation.explicitRequired": "A seleção do tipo de conteúdo é obrigatória",
    "validation.coverRequired": "A imagem da capa é obrigatória",
    "validation.songwriterRequired": "Pelo menos um compositor é necessário",
    "validation.contributorRequired": "Pelo menos um colaborador é necessário",
    "validation.productionTeamRequired": "Pelo menos um membro da equipe de produção é necessário",
    "validation.platformRequired": "Pelo menos uma plataforma deve ser selecionada",
    "validation.releaseDateRequired": "A data de lançamento é obrigatória",
    "validation.trackCountRequired": "Pelo menos 2 faixas são necessárias para EP/Álbum",
    "releases.track": "Faixa",
    
    // Toast Messages
    "toast.saveSuccess": "Salvo com sucesso",
    "toast.saveFailed": "Falha ao salvar",
    "toast.deleteSuccess": "Excluído com sucesso",
    "toast.uploadSuccess": "Enviado com sucesso",
    "toast.submitSuccess": "Enviado com sucesso",
    "toast.loginSuccess": "Login realizado com sucesso",
    "toast.copySuccess": "Copiado para a área de transferência",
    "toast.errorOccurred": "Ocorreu um erro",
    "toast.pleaseFixErrors": "Por favor, corrija os erros nesta seção",
    
    // Spotify
    "spotify.comingSoon": "Em Breve",
};

export default pt;
